import { useLocation, useParams } from 'react-router';

const useIntervieweeId = () => {
	const { intervieweeId } = useParams();
	const location = useLocation();

	if (intervieweeId) {
		return intervieweeId;
	}

	return new URLSearchParams(location.search.toLowerCase()).get('intervieweeid');
};

export default useIntervieweeId;
